const mergeInvoiceInstanceValues = ({
  currentValues,
  instanceValues,
  preserveNominalId,
}) => ({
  ...currentValues,
  ...Object.fromEntries(
    Object.entries(instanceValues || {}).filter(([, value]) => value != null),
  ),
  ...(preserveNominalId ? { nominalId: currentValues?.nominalId } : {}),
});

export { mergeInvoiceInstanceValues };
